/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Image_Models_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configure which image generation models are available in your organization." |
*
* @param {Org_Image_Models_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_image_models_description = /** @type {((inputs?: Org_Image_Models_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Image_Models_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie, welche Bildgenerierungsmodelle in Ihrer Organisation verfügbar sind.")
	return /** @type {LocalizedString} */ ("Configure which image generation models are available in your organization.")
});